<template>
  <div class="chargify-from">
    <v-chip
      @click="togglePaymentType('card')"
      label
      :color="isActive('card')"
      text-color="white"
      class="caption"
      :data-test-id="`${dataTestId}__cards-chip`"
    >
      Cards
    </v-chip>

    <v-chip
      @click="togglePaymentType('direct_debit')"
      :color="isActive('direct_debit')"
      class="ma-2 caption"
      text-color="white"
      label
      :data-test-id="`${dataTestId}__direct-debit-chip`"
    >
      Direct Debit
    </v-chip>

    <form
      id="chargify-form-card"
      @submit="handleSubmit"
      :data-test-id="`${dataTestId}__cards-chip__form`"
    >
      <div class="w-100">
        <div v-if="paymentType === 'direct_debit'" class="mt-4">
          <label class="formInputLabel font700 mb-2">Business Name</label>
          <v-text-field
            label="Business Name"
            :value="currentOrgName"
            class="business-name"
            disabled
            solo
            filled
            flat
            hide-details
            :background-color="colors.secondaryBackground"
          />
        </div>
        <div id="chargify-form">
          <div class="d-flex flex-row chargify-form-row align-items-start">
            <div
              id="Fname"
              :data-test-id="`${dataTestId}__cards-chip__first-name-input`"
            ></div>
            <div
              class="ml-6"
              id="Lname"
              :data-test-id="`${dataTestId}__cards-chip__last-name-input`"
            ></div>
          </div>

          <div>
            <div
              id="Cnumber"
              :data-test-id="`${dataTestId}__cards-chip_card-number-input`"
            ></div>
          </div>
          <div class="d-flex flex-row chargify-form-row align-items-start">
            <div
              id="MM"
              :data-test-id="`${dataTestId}__cards-chip__month-input`"
            ></div>
            <div
              class="ml-3"
              id="YY"
              :data-test-id="`${dataTestId}__cards-chip__year-input`"
            ></div>
            <div
              class="ml-3"
              id="CVV"
              :data-test-id="`${dataTestId}__cards-chip__cvv-input`"
            ></div>
          </div>
        </div>
        <slot v-if="paymentType === 'card'" name="chargify-button"></slot>
      </div>
    </form>

    <form
      id="chargify-form-direct-debit"
      @submit="handleSubmit"
      :data-test-id="`${dataTestId}__direct_debit-chip__form`"
    >
      <div class="w-100">
        <div id="chargify1"></div>
        <div id="chargify2"></div>
        <div id="chargify3"></div>
        <div id="chargify4"></div>
        <div id="chargify5"></div>
        <div id="chargify6"></div>
        <div id="chargify7"></div>
        <div id="chargify8"></div>
        <div id="chargify9"></div>
        <div id="chargify10"></div>
        <div id="chargify11"></div>
        <div id="chargify12"></div>
        <div id="chargify13"></div>
        <div id="chargify14"></div>
      </div>

      <slot v-if="paymentType === 'direct_debit'" name="chargify-button"></slot>
    </form>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import config from '../../../config';
export default {
  created() {
    this.Chargify = new window.Chargify();
  },
  props: ['dataTestId'],
  computed: {
    ...mapState(['currentOrgData']),
    colors() {
      return this.$vuetify?.theme?.themes?.light;
    },
    currentOrgName() {
      return this.currentOrgData?.name || '';
    }
  },
  methods: {
    togglePaymentType(paymentType) {
      this.paymentType = paymentType;
      this.$emit('getPaymentType', this.paymentType);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.$emit('disableSubmitButton', this.paymentType);
      const form = document.querySelector('#chargify-form');
      this.Chargify.token(
        form,
        token => {
          this.token = token;
          this.$emit('createPaymentProfile', token);
        },

        error => {
          let errorMessage = error?.invalidFields?.join(', ');
          if (errorMessage) {
            errorMessage += ' invalid';
          }
          this.$emit('createPaymentProfile', false);
          this.snackbar('error', errorMessage || error.errors);
        }
      );
    },
    isActive(type) {
      if (type === this.paymentType) {
        return '#58e2c2';
      }
    },
    load() {
      const fields = {
        card: {
          firstName: {
            selector: '#Fname',
            required: true
          },
          lastName: {
            selector: '#Lname',
            required: true
          },
          number: {
            selector: '#Cnumber',
            style: {
              input: {
                display: 'block',
                width: '100%',
                padding: '10px 20px',
                paddingLeft: '50px',
                backgroundColor: '#eeeeee',
                border: '2px solid #eeeeee',
                outline: '0',
                fontSize: '1rem',
                margin: '5px 0 0 0',
                borderRadius: 0,
                lineHeight: 'normal',
                minHeight: 'unset'
              },
              img: {
                top: '4px'
              }
            },
            next_focus: 'month'
          },
          month: {
            selector: '#MM',
            label: 'Month',
            style: {},
            next_focus: 'year'
          },
          year: {
            selector: '#YY',
            label: 'Year',
            placeholder: 'YYYY',
            style: {},
            next_focus: 'cvv'
          },
          cvv: {
            selector: '#CVV',
            label: 'CVC',
            placeholder: 'CVC',
            style: {},
            required: true
          }
        },
        direct_debit: {
          // country: { selector: '#chargify3' },
          // address: { selector: '#chargify4' },
          // address2: { selector: '#chargify5' },
          // city: { selector: '#chargify6' },
          // state: { selector: '#chargify7' },
          // zip: { selector: '#chargify8' },
          // bankName: { selector: '#chargify9' },
          // bankIban: { selector: '#chargify10' },
          // branchCode: { selector: '#chargify11' },
          // routingNumber: { selector: '#chargify12' },
          // accountNumber: { selector: '#chargify13' },
          // accountHolderType: { selector: '#chargify14' }
        }
      };
      let chargifyConfig = {
        direct_debit: {
          selector: '#chargify-form-direct-debit',
          type: 'direct_debit'
        },
        card: {
          selector: '#chargify-form-card'
          // hideCardImage: true,
        }
      };

      // this.Chargify.load({
      //   selector: '#chargify1',
      //   publicKey: config.chargifyPublicKey,

      //   serverHost: config.chargifyServerHost,
      //   gatewayHandle: config.charifyGateway.direct_debit
      // });
      this.Chargify.load({
        // selector where the iframe will be included in the host's HTML (i.e. '#chargify-form')
        // optional if you have a `selector` on each and every field
        ...chargifyConfig[this.paymentType],
        style: {
          // `field` is the container for each field
          // `input` is the input HTML element
          input: {
            display: 'block',
            width: '100%',
            padding: '10px 20px',
            backgroundColor: '#eeeeee',
            border: '2px solid #eeeeee',
            outline: '0',
            fontSize: '1rem',
            margin: '5px 0 0 0',
            borderRadius: 0,
            lineHeight: 'normal',
            minHeight: 'unset'
          },
          label: {
            fontSize: '14px',
            fontWeight: '700'
          },
          field: {
            fontFamily: 'Muli, sans-serif'
          }
        },
        //hide card image

        // (i.e. '1a2cdsdn3lkn54lnlkn')
        publicKey: config.chargifyPublicKey,
        gatewayHandle: config.charifyGateway[this.paymentType],
        // form type (possible values: 'card' or 'bank')
        type: this.paymentType,
        // points to your Chargify site
        serverHost: config.chargifyServerHost,
        fields: fields[this.paymentType]
      });
    },
    unload() {
      this.Chargify.unload();
    }
  },
  mounted() {
    this.load();
  },
  destroyed() {
    this.unload();
  },
  watch: {
    paymentType() {
      this.unload();
      this.Chargify = new window.Chargify();

      this.load();
    }
  },
  data() {
    return {
      token: '',
      Chargify: null,
      paymentType: 'card',
    };
  }
};
</script>

<style>
#Cnumber iframe,
#MM iframe,
#YY iframe,
#Fname iframe,
#Lname iframe,
#CVV iframe {
  width: 100% !important;
}
.chargify-from .v-chip .v-chip__content {
  color: #fff !important;
}
.chargify-from .v-chip--no-color .v-chip__content {
  color: #000 !important;
}
#chargify-form-direct-debit {
  display: flex !important;
  flex-direction: column-reverse;
}
.business-name > .v-input__control > .v-input__slot {
  min-height: 42px !important;
}
</style>
<style scoped>
.chargify-form-row div {
  width: 100%;
}
@media (max-width: 600px) {
  .chargify-form-row {
    flex-direction: column !important;
    align-items: start !important;
  }
  .chargify-form-row div {
    margin-left: 0 !important;
  }
}
</style>
